import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, Subject} from "rxjs";
import {timeout} from "rxjs/operators";
import {ConfigService} from "./config.service";
import {FileUpload} from "primeng/fileupload";


@Injectable({
    providedIn: 'root'
})
export class RestBackendService {
    myServiceUri: Subject<string> = new Subject<string>();
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'charset=utf-8'
        }),
        withCredentials: true
    };

    constructor(protected _http: HttpClient, private config: ConfigService, @Inject(LOCALE_ID) public locale: string) {
        this.httpOptions.headers.set("local", this.locale);
    }

    doGetPath(path: string): Promise<string> {
        var httpOp = {
            headers: new HttpHeaders({
                'Content-Type': '',
                'local': this.locale
            }),
            withCredentials: false
        };
        return this._http.get<string>(path, httpOp).pipe(timeout(30000)).toPromise();
    }

    doGet(path: string): Observable<string> {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'charset=utf-8',
                'local': this.locale
            }),
            withCredentials: true
        }
        return  this._http.get<string>(this.config.getBaseUrl() + path, this.httpOptions).pipe(timeout(30000));
    }


    doGetAccunting(path: string): Promise<string> {
        return this._http.get<string>(this.config.getAccountingUrl() + path, this.httpOptions).pipe(timeout(30000)).toPromise();
    }

    doGetFile(path: string): Promise<any> {
        const httpOp = {
            headers: new HttpHeaders({
                "Content-disposition": "attachment;filename=file.zip",
                "content-type": "application/zip",
                Accept: 'application/zip',
                local: this.locale
            }),
            withCredentials: true,
            responseType: 'arraybuffer'

        };

        // @ts-ignore
        return this._http.get<any>(this.config.getBaseUrl() + path, httpOp).pipe(timeout(30000)).toPromise();
    }


    doUploadPost(path: String, file: any, params: any): Promise<any> {

        const options = {
            // headers: new HttpHeaders({
            //     "Content-Type": "multipart/form-data"
            // }),
            params: params,
            withCredentials: true
        };
        let formData = new FormData();
        formData.append('file', file);
        return this._http.post<any>(this.config.getBaseUrl() + path, formData, options).pipe(timeout(10000)).toPromise();
    }

    doGetBlob(path: String): Promise<any> {
        const options = {
            headers: new HttpHeaders({
                "Content-disposition": "attachment;filename=config.json",
                Accept: 'application/json',
                local: this.locale
            }),
            withCredentials: true
        };

        return this._http.get(this.config.getBaseUrl() + path, options).pipe(timeout(30000)).toPromise();
    }

    doPost(path: String, body: any, params: any): Promise<String> {
        // if (localStorage.getItem("token") != null) {
        //     this.addHeader("token", localStorage.getItem("token"));
        // } else {
        //     this.removeHeader("token");
        // }
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                local: this.locale
            }),
            params: params,
            withCredentials: true
        };

        return this._http.post<String>(this.config.getBaseUrl() + path, body, options).pipe(timeout(30000)).toPromise();
    }


//..............header.......................
    addHeader(key: string, value: string) {
        this.httpOptions.headers = this.httpOptions.headers.set(key, value);
    }

    removeHeader(key: string) {
        this.httpOptions.headers = this.httpOptions.headers.delete(key);
    }

    getHeader(key: string): string {
        return (this.httpOptions.headers.get(key) || '');
    }

}
